import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FaUserAlt, FaLock } from "react-icons/fa";

import { fetchCurrentUser, login } from "../slices/auth";
import { clearMessage } from "../slices/message";
import logo from "../assets/images/LogoMercadito.png";
import { AppDispatch } from "../store";
import { useAppDispatch } from "../hooks";
import { ILoginFormValues, IRootState } from "../interfaces/types";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useAppDispatch();

  const [loading, setLoading] = useState<boolean>(false);
  const message = useSelector((state: IRootState) => state.message.message);

  useEffect(() => {
    dispatch(clearMessage());
  }, [dispatch]);

  const initialValues: ILoginFormValues = {
    username: "",
    password: "",
  };

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("Nombre de usuario requerido"),
    password: Yup.string().required("Contraseña requerida"),
  });

  const handleLogin = async ({ username, password }: ILoginFormValues) => {
    setLoading(true);

    dispatch(login({ username, password }))
      .unwrap()
      .then(() => dispatch(fetchCurrentUser()).unwrap())
      .then(() => {
        navigate("/admin-home");
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <main className="main login-page">
      <section className="login-content">
        <div className="login-logo-container">
          <img src={logo} alt="Webb Logo" className="login-logo" />
        </div>

        <div className="login-card">
          <h1 className="login-title">Bienvenido</h1>
          <p className="login-subtitle">Ingrese sus credenciales para continuar</p>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleLogin}
          >
            <Form className="login-form-container">
              <div className="login-field-group">
                <div className="login-input-wrapper">
                  <FaUserAlt className="login-input-icon" />
                  <Field
                    name="username"
                    type="text"
                    placeholder="Nombre de usuario"
                    className="form-control login-input"
                    autoComplete="username"
                  />
                </div>

                <ErrorMessage
                  name="username"
                  component="div"
                  className="alert alert-danger login-error"
                />
              </div>

              <div className="login-field-group">
                <div className="login-input-wrapper">
                  <FaLock className="login-input-icon" />
                  <Field
                    name="password"
                    type="password"
                    placeholder="Contraseña"
                    className="form-control login-input"
                    autoComplete="current-password"
                  />
                </div>

                <ErrorMessage
                  name="password"
                  component="div"
                  className="alert alert-danger login-error"
                />
              </div>

              <button
                type="submit"
                className="btn login-submit-btn"
                disabled={loading}
              >
                {loading && (
                  <span className="spinner-border spinner-border-sm me-2" />
                )}
                Ingresar
              </button>
            </Form>
          </Formik>

          <Link to="/forgot-password" className="forgot-password-link">
            ¿Olvidó su contraseña?
          </Link>

          {message && (
            <div className="alert alert-danger login-message" role="alert">
              {message}
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default Login;
